import { useQuery } from '@tanstack/react-query';
import { getMyAssignments } from '../api';

export function useMyAssignments(enabled = true) {
  return useQuery({
    queryKey: ['myAssignments'],
    queryFn: async () => {
      const res = await getMyAssignments();
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    enabled
  });
}
